import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

const AudienceListener = () => {
  const history = useHistory()
  const { pathname } = useLocation()
  const { selectedAudienceId } = useSelector(state => state.system)

  React.useEffect(() => {
    const id = selectedAudienceId

    // Ignore "Semua Orang"
    if(id && id !== 1){
      history.replace(`${pathname}?audience=${id}`)
    }
    // eslint-disable-next-line
  }, [])

  return <></>
}

export default AudienceListener
